export class RulePropertyEditEvent<T> {
  notificationRuleId: string;
  value: T;
}
